import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Kurumsal: React.FC = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="kurumsal" className="section kurumsal-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">{t('about.title')}</h2>
          <p className="section-subtitle">{t('about.subtitle')}</p>
        </motion.div>

        <motion.div
          className="kurumsal-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div className="kurumsal-card" variants={itemVariants}>
            <h3>{t('about.mission.title')}</h3>
            <p>{t('about.mission.desc')}</p>
          </motion.div>

          <motion.div className="kurumsal-card" variants={itemVariants}>
            <h3>{t('about.vision.title')}</h3>
            <p>{t('about.vision.desc')}</p>
          </motion.div>

          <motion.div className="kurumsal-card" variants={itemVariants}>
            <h3>{t('about.values.title')}</h3>
            <ul>
              {[0, 1, 2, 3, 4].map((index) => (
                <li key={index}>{t(`about.values.items.${index}`)}</li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Kurumsal;